import { useQuery } from '@tanstack/react-query';
import type { SchoolSizeCostFilterParams, SchoolSizeCostResult } from '@/features/reports/data/schoolSizeCost.types';
import {
  filterParamsToSchoolSizeCostApiParams,
  schoolSizeCostApi,
} from '@/features/reports/api/schoolSizeCost.api';

export const schoolSizeCostQueryKeys = {
  all: ['school-size-cost'] as const,
  search: (params: SchoolSizeCostFilterParams) =>
    [...schoolSizeCostQueryKeys.all, 'search', params] as const,
};

const PLACEHOLDER_PARAMS: SchoolSizeCostFilterParams = {
  year: '',
};

/**
 * Loads School Size vs Cost from GET /api/app/school-size-cost/school-size-costs.
 */
export function useSchoolSizeCostQuery(
  params: SchoolSizeCostFilterParams | null,
  enabled: boolean
) {
  const queryEnabled = enabled && params != null && Boolean(params.year?.trim());

  return useQuery<SchoolSizeCostResult>({
    queryKey: schoolSizeCostQueryKeys.search(params ?? PLACEHOLDER_PARAMS),
    queryFn: async () => {
      const apiParams = filterParamsToSchoolSizeCostApiParams(params!);
      if (!apiParams) {
        throw new Error('Invalid search parameters.');
      }
      return schoolSizeCostApi.getSchoolSizeCosts(apiParams);
    },
    enabled: queryEnabled,
    staleTime: 0,
  });
}
